import { cn } from '@/lib/utils';

function TextCodeOrder({ id, className }: { id: string; className?: string }) {
  return (
    <div
      className={cn(
        'relative inline-flex items-center gap-2 bg-gradient-to-r from-emerald-500 via-teal-500 to-cyan-500 px-2 py-1 rounded-2xl border-2 border-white shadow-xl text-white font-bold text-sm overflow-hidden before:absolute before:inset-0 before:bg-gradient-to-r before:from-white/20 before:via-transparent before:to-white/20 before:translate-x-[-100%] hover:before:translate-x-[100%] before:transition-transform before:duration-1000 hover:shadow-emerald-500/50 hover:border-emerald-200 transition-all duration-300',
        className
      )}
    >
      <div className="relative z-10 flex items-center gap-2">
        <div className="w-1.5 h-1.5 bg-white rounded-full opacity-90"></div>
        <span className="font-extrabold tracking-wider drop-shadow-sm">
          ADDH
        </span>
        <div className="w-px h-4 bg-white/40"></div>
        <span className="font-mono font-bold tracking-wide">{id}</span>
      </div>
    </div>
  );
}

export default TextCodeOrder;
